import type { IconData } from '@stacksjs/iconify-core'

export const screen1Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 36.498c-7.423 0-12.616-.213-15.875-.416c-3.236-.201-5.868-2.602-6.174-5.9c-.235-2.526-.451-6.204-.451-11.184s.216-8.658.45-11.183c.307-3.299 2.939-5.7 6.175-5.901c3.259-.203 8.452-.416 15.875-.416s12.616.213 15.875.416c3.236.201 5.868 2.602 6.174 5.9c.235 2.526.451 6.204.451 11.184s-.216 8.658-.45 11.183c-.307 3.299-2.939 5.7-6.175 5.901c-3.259.203-8.452.416-15.875.416m0 3q-2.724-.001-5.062-.035l-.215 1.72a1.5 1.5 0 0 1-1.488 1.315h-2.85a2.42 2.42 0 0 0-2.297 1.656a1.78 1.78 0 0 0 1.69 2.344h20.445a1.78 1.78 0 0 0 1.69-2.344a2.42 2.42 0 0 0-2.298-1.656h-2.85a1.5 1.5 0 0 1-1.488-1.314l-.215-1.721q-2.338.034-5.062.035\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default screen1Solid
